module.exports = __webpack_public_path__ + "media/images/classpoints/brands/AKT-cea68b1df4d0e43ad07c249b4aae19e7.svg";